module.exports = __webpack_public_path__ + "img/email.f0fcc855.svg";